export const resultText = {
  Pass: 'Pass',
  Fail: 'Fail',
  Pending: 'Pending',
};

export const resultTextColors = {
  Pass: 'green',
  Fail: 'red',
  Pending: 'blue',
  Default: '',
};
